const selectNavigators = document.querySelectorAll('.js-select-navigator');

selectNavigators.forEach(selectNavigator => {
  selectNavigator.addEventListener('change', () => {
    if(selectNavigator.options[selectNavigator.selectedIndex].value !== window.location.pathname) {
      window.location.href = selectNavigator.options[selectNavigator.selectedIndex].value;
    }
  })
})
